import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, FreeMode, Navigation, Thumbs } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

import './project-slideshow.css';

export const ProjectSlideshow = ({ images, title, className }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  if (!images || images.length === 0) {
    return null;
  }

  return (
    <div className={className}>
      <Swiper
        style={{
          '--swiper-navigation-color': '#4db5ff',
          '--swiper-pagination-color': '#4db5ff',
        }}
        spaceBetween={10}
        navigation={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        thumbs={{
          swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null
        }}
        modules={[FreeMode, Navigation, Thumbs, Autoplay]}
        className="mySwiper2"
      >
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <div className="slide-image-container">
              <img
                src={image.src}
                alt={`${title} - ${image.alt || `Imagen ${index + 1}`}`}
                className="slide-image"
              />
              {image.alt && (
                <div className="slide-caption">
                  <p>{image.alt}</p>
                </div>
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <Swiper
        onSwiper={setThumbsSwiper}
        spaceBetween={10}
        slidesPerView={4}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper"
      >
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <img
              src={image.src}
              alt={`${title} - ${image.alt || `Miniatura ${index + 1}`}`}
              className="thumbnail-image"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};